/* MXDVS archived product page, assets/mxdvs-product-archived.js (01.10.2026), demo B "Declassified".
   Loaded only by sections/mxdvs-product-archived.liquid. Waits for assets/mxdvs-product.js to build the page,
   then: Archived tag, dates under the name, price, sizes and parts of the description decode into redaction
   blocks, a file stamp is pressed next to the dates, "Archived on" decodes and lights up.
   The button is switched off and every Notify me link is removed. The base page files are not changed. */
(function () {
  var cfgEl = document.querySelector('[data-mxp-archived]');
  if (!cfgEl || window.MxArchived) return;
  window.MxArchived = true;
  var C = JSON.parse(cfgEl.textContent);
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var GL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%&*/<>';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function decode(el, txt, ms, done) {
    if (RM) { el.textContent = txt; if (done) done(); return; }
    var n = txt.length, t0 = performance.now();
    (function f(now) {
      var p = Math.min(1, (now - t0) / ms), k = Math.floor(p * n), s = txt.slice(0, k);
      for (var i = k; i < n; i++) s += txt[i] === ' ' ? ' ' : GL[(Math.random() * GL.length) | 0];
      el.textContent = s;
      if (p < 1) requestAnimationFrame(f); else { el.textContent = txt; if (done) done(); }
    })(t0);
  }

  function stamp() {
    var t = Math.max(0.45, 0.78 - C.wear / 100 * 0.33), m = (-14 * t).toFixed(2);
    return '<svg viewBox="0 0 260 150" role="img" aria-label="' + esc(C.stampText + ', ' + C.archivedOn) + '"><defs>' +
      '<filter id="arcRough"><feTurbulence type="fractalNoise" baseFrequency=".07" numOctaves="2" seed="3"/><feDisplacementMap in="SourceGraphic" scale="2.2"/></filter>' +
      '<filter id="arcNoise"><feTurbulence type="fractalNoise" baseFrequency="1.1" numOctaves="2" seed="5"/><feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  14 0 0 0 ' + m + '"/></filter>' +
      '<mask id="arcWear"><rect width="260" height="150" fill="#fff"/><rect width="260" height="150" filter="url(#arcNoise)"/></mask></defs>' +
      '<g mask="url(#arcWear)" filter="url(#arcRough)" fill="currentColor" font-family="Roboto Mono,ui-monospace,monospace">' +
      '<rect x="4" y="4" width="252" height="142" rx="5" fill="none" stroke="currentColor" stroke-width="4"/>' +
      '<path d="M4 42 H256 M4 112 H256" stroke="currentColor" stroke-width="2"/>' +
      '<text x="17" y="29" font-size="13" font-weight="700">MXDVS / ' + esc(String(C.fileNo).toUpperCase()) + '</text>' +
      '<text x="130" y="91" font-family="Helvetica Neue,Helvetica,Arial,sans-serif" font-size="40" font-weight="700" text-anchor="middle" textLength="220" lengthAdjust="spacingAndGlyphs">' + esc(String(C.stampText).toUpperCase()) + '</text>' +
      '<text x="17" y="134" font-size="13" font-weight="700">' + esc(C.archivedOn) + '</text>' +
      '<text x="243" y="134" font-size="13" font-weight="700" text-anchor="end">' + esc(String(C.notForSale).toUpperCase()) + '</text></g></svg>';
  }

  var played = false;
  function apply(view) {
    var info = view.querySelector('.pp-info');
    if (!info || info.hasAttribute('data-arc') || !view.classList.contains('pp--a')) return;
    info.setAttribute('data-arc', '');
    view.classList.add('pp--archived');
    var animate = !played && !RM; played = true;

    /* Tag next to the name */
    var title = info.querySelector('.pp-title');
    if (title) {
      title.querySelectorAll('.pp-tag,.pp-badge').forEach(function (t) { t.remove(); });
      title.insertAdjacentHTML('beforeend', '<span class="pp-tag pp-tag--out">' + esc(C.tag) + '</span>');
    }
    info.querySelectorAll('[data-act="notify"],.pp-tag--sale').forEach(function (n) { n.remove(); });

    /* Dates and the file stamp under the name */
    var head = info.querySelector('.pp-head'), line = null, file = null;
    if (head && (C.released || C.archivedOn)) {
      var h = '<div class="arc-rec"><div class="arc-lines">';
      if (C.released) h += '<span>&gt; ' + esc(C.releasedLabel) + ' ' + esc(C.released) + '</span>';
      if (C.archivedOn) { var lt = '> ' + C.archivedLabel + ' ' + C.archivedOn; h += '<span class="arc-line" data-t="' + esc(lt) + '">' + esc(lt) + '</span>'; }
      h += '</div>' + (C.archivedOn ? '<div class="arc-file">' + stamp() + '</div>' : '') + '</div>';
      head.insertAdjacentHTML('afterend', h);
      line = info.querySelector('.arc-line'); file = info.querySelector('.arc-file');
    }

    /* Button and sizes switched off */
    var atc = info.querySelector('.pp-atc');
    if (atc) {
      atc.disabled = true; atc.removeAttribute('data-act'); atc.classList.add('is-archived'); atc.setAttribute('aria-disabled', 'true');
      var tx = atc.querySelector('.pp-txt');
      if (tx) { if (animate) decode(tx, C.button, 500); else tx.textContent = C.button; tx.setAttribute('data-t', C.button); }
    }
    info.querySelectorAll('.pp-size').forEach(function (b) { b.disabled = true; b.classList.add('is-archived'); b.setAttribute('aria-disabled', 'true'); });

    /* What gets redacted */
    /* 09.10.2026: the price is no longer redacted: it decodes, stays readable and a red line draws through it */
    var rx = [], sk = [];
    if (C.redactPrice) info.querySelectorAll('.pp-price > span, .pp-price > s').forEach(function (e) { sk.push(e); });
    if (C.redactSizes) info.querySelectorAll('.pp-size > span').forEach(function (e) { rx.push(e); });
    if (C.redactDesc && C.descSelector) {
      try {
        var sel = C.descSelector.split(',').map(function (s) { return '[data-pl-desc] ' + s.trim(); }).join(', ');
        view.querySelectorAll(sel).forEach(function (e) { if (!e.classList.contains('arc-blk')) rx.push(e); });
      } catch (e) {}
    }

    if (!animate) {
      rx.forEach(function (e) { e.classList.add('arc-blk'); });
      sk.forEach(function (e) { e.classList.add('arc-strike', 'is-drawn'); });
      if (file) file.classList.add('is-set');
      if (line) line.classList.add('is-set', 'is-lit');
      return;
    }
    setTimeout(function () {
      rx.forEach(function (e, i) {
        setTimeout(function () { var t = e.textContent; e.classList.add('arc-dec'); decode(e, t, C.decodeMs, function () { e.classList.add('arc-blk'); }); }, i * C.stagger);
      });
      sk.forEach(function (e, i) {
        setTimeout(function () { var t = e.textContent; e.classList.add('arc-strike'); decode(e, t, C.decodeMs, function () { requestAnimationFrame(function () { e.classList.add('is-drawn'); }); }); }, i * C.stagger);
      });
    }, C.redactStart);
    if (file) setTimeout(function () { file.classList.add('is-on'); }, C.stampAt);
    if (line) setTimeout(function () {
      var t = line.textContent; line.classList.add('is-set');
      decode(line, t, C.lineMs, function () { line.classList.add('is-lit', 'is-sweep'); });
    }, C.lineAt);
  }

  function boot() {
    document.querySelectorAll('[data-mxp-view]').forEach(function (view) {
      apply(view);
      /* The base page draws the page after this script on some loads, and redraws the product info after a
         click (wishlist): the archived state is put back each time, the animation only plays once */
      if (!view._arcObs) { view._arcObs = new MutationObserver(function () { apply(view); }); view._arcObs.observe(view, { childList: true }); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { played = false; boot(); });
})();
